import { render, staticRenderFns } from "./BusDriver.vue?vue&type=template&id=72fdb46d&scoped=true"
import script from "./BusDriver.vue?vue&type=script&lang=js"
export * from "./BusDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fdb46d",
  null
  
)

export default component.exports